import { gql } from '@apollo/client';

/**
 * Query the authenticated user's own recurring weekly schedule pattern.
 */
export const GET_MY_SCHEDULE = gql`
  query GetMySchedule {
    mySchedule {
      dayOfWeek
      isWorking
      isRemote
    }
  }
`;

/**
 * Query the authenticated user's own time-off entries within an optional date range.
 */
export const GET_MY_VACATIONS = gql`
  query GetMyVacations($startDate: Timestamp, $endDate: Timestamp) {
    myVacations(startDate: $startDate, endDate: $endDate) {
      id
      userId
      startDate
      endDate
      vacationType
      reason
      approvalStatus
      reviewedAt
      reviewNote
      reviewedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

/**
 * The authenticated user's own annual PTO balance. Team-wide balances are
 * otherwise restricted to administrators.
 */
export const GET_MY_PTO_DAYS_REMAINING = gql`
  query GetMyPtoDaysRemaining {
    myPtoDaysRemaining
  }
`;

/**
 * Query company holidays visible to the authenticated user, used for the monthly
 * calendar preview on the My Availability page.
 */
export const GET_MY_COMPANY_HOLIDAYS = gql`
  query GetMyCompanyHolidays($startDate: Timestamp, $endDate: Timestamp, $year: Int) {
    myCompanyHolidays(startDate: $startDate, endDate: $endDate, year: $year) {
      id
      name
      date
      description
    }
  }
`;

/**
 * Query the authenticated user's currently selected coverage / back-up contact.
 */
export const GET_MY_COVERAGE = gql`
  query GetMyCoverage {
    myCoverage {
      id
      firstName
      lastName
      name
      role
      email
      phoneNumber
      avatarUrl
    }
  }
`;

/**
 * Query users eligible to be selected as the caller's coverage contact:
 * active users outside housekeeping roles, excluding the caller.
 */
export const GET_COVERAGE_ELIGIBLE_USERS = gql`
  query GetCoverageEligibleUsers {
    coverageEligibleUsers {
      id
      firstName
      lastName
      name
      role
      email
      phoneNumber
      avatarUrl
    }
  }
`;

/**
 * Query the authenticated user's per-date schedule overrides within a range.
 * Each override replaces the recurring weekly pattern for that specific date.
 */
export const GET_MY_SCHEDULE_OVERRIDES = gql`
  query GetMyScheduleOverrides($startDate: Timestamp, $endDate: Timestamp) {
    myScheduleOverrides(startDate: $startDate, endDate: $endDate) {
      id
      date
      isWorking
      isRemote
      notes
    }
  }
`;
